import api from '../api'

const createAttachment = (token, data) => {
  return api.privatePost(`/v1/helpscout/attachments/`, { token, data })
}

export default {
  createAttachment
}
